import { mapState as rootMapState } from 'pinia';
import { useUserStore } from '@/store';
import global from '@/common/global';
import signLog from '@/components/sign-log';
import { colorBlock } from '../defaultSpacing';
import util from '@/common/util';
export default {
    i18next: {
        ns: 'md-cta-multiple-column'
    },
    data: function() {
        return {
            ...colorBlock
        };
    },
    mounted() {
        this.currentWidth = window.innerWidth;
        this.calcStyle(true);
        global.resize(this.calcStyle);
    },
    unmounted() {
        global.resize(this.calcStyle, true);
    },
    computed: {
        ...rootMapState(useUserStore, {
            "user": store => store.user
        }),
        isMobile() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobile ? this.mobileTopSpacing : this.topSpacing) + 'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobile ? this.mobileBtmSpacing : this.btmSpacing) + 'px'
            );
        }
    },
    methods: {
        calcStyle(flag) {
            if (
                flag !== true &&
                this.isMobile &&
                this.currentWidth &&
                this.currentWidth === window.innerWidth
            ) {
                return; 
            }
            this.currentWidth = window.innerWidth;
            const sizeOption = this.blockSizeOption || {};
            const ele =
                this.$refs.content && this.$refs.content.$el
                    ? this.$refs.content.$el
                    : this.$refs.content;
            let type = sizeOption.type;
            //  The module defaults to fullColumn， So the module's width is not fixed , initially switch to ratio need to calculate dynamically ， current aspect ratio 
            let ratio =
                sizeOption.ratio ||
                parseInt((sizeOption.height * 100) / ele.offsetWidth);
            let height = sizeOption.height;
            let minHeight = 0;
            if (this.isMobile) {
                type = sizeOption.mobileType;
                ratio =
                    sizeOption.mobileRatio ||
                    parseInt((sizeOption.mobileHeight * 100) / ele.offsetWidth);
                height = sizeOption.mobileHeight;
            }
            if (type === 'scale') {
                minHeight = (ele.offsetWidth * ratio) / 100;
            } else if (type === 'fullScreen') {
                minHeight = Math.max(
                    window.innerHeight - this.$el.offsetTop,
                    500
                );
            } else if (type === 'height') {
                minHeight = height;
            }
            this.minHeight = minHeight;
        },
        //  This method is in config.js call in ， calculate actual size 
        calcRealSize() {
            const sizeOption = this.blockSizeOption || {};
            let type = sizeOption.type;
            let ratio = sizeOption.ratio;
            let height = sizeOption.height;
            if (this.isMobile) {
                type = sizeOption.mobileType;
                ratio = sizeOption.mobileRatio;
                height = sizeOption.mobileHeight;
            }
            const ele =
                this.$refs.content && this.$refs.content.$el
                    ? this.$refs.content.$el
                    : this.$refs.content;
            if (ele) {
                if (type === 'scale') {
                    ratio = (ele.offsetHeight / ele.offsetWidth) * 100;
                } else if (type === 'height') {
                    height = ele.offsetHeight;
                }
            }
            return {
                type: sizeOption.type,
                mobileType: sizeOption.mobileType,
                ratio: this.isMobile ? sizeOption.ratio : ratio,
                mobileRatio: this.isMobile ? ratio : sizeOption.mobileRatio,
                height: this.isMobile ? sizeOption.height : height,
                mobileHeight: this.isMobile ? height : sizeOption.mobileHeight
            };
        },
        showRegisterPop(info) {
            let role = info?.registerRole || '';
            let tag = info?.tag || '';
            if (!this.user) {
                signLog.register({
                    role,
                    registerData: {
                        tag
                    }
                });
            } else {
                util.toast(
                    this.$t('md-cta-multiple-column.youAreAlreadyLogged'),
                    2000
                );
            }
        }
    }
};
